module.exports = __webpack_public_path__ + "static/img/donate-blood-03.1ab43f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/charitable-activities/donate-blood-03.jpg
// module id = a92e
// module chunks = 100